import { RunningExperiments, useExperiments } from 'state/experiments';

export const useEnableSignUpSignInABTest = () => {
  const { variant } = useExperiments();

  return variant(RunningExperiments.SignUpSignInABTest, 'treatment');
};
